import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index.js";

import vue3videoPlay from "vue3-video-play"; // 引入组件
import "vue3-video-play/dist/style.css";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueNumberFormat from "vue-number-format";

import { OhVueIcon, addIcons } from "oh-vue-icons";
import {
  FaFlag,
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  MdFeedbackOutlined,
} from "oh-vue-icons/icons";

addIcons(FaFlag, FaFacebookF, FaInstagram, FaTiktok, MdFeedbackOutlined);

const app = createApp(App);

app.component("v-icon", OhVueIcon);
app.use(vue3videoPlay);
app.use(VueNumberFormat, {
  prefix: "",
  decimal: ".",
  thousand: ",",
  precision: 0,
  acceptNegative: false,
});
app.use(router);
app.mount("#app");
